import { render, staticRenderFns } from "./WorkflowPrepTaskAuditTrailHistory.vue?vue&type=template&id=de58bc9c"
import script from "./WorkflowPrepTaskAuditTrailHistory.vue?vue&type=script&lang=js"
export * from "./WorkflowPrepTaskAuditTrailHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports